import { createContext, useContext, useState, useEffect } from "react";

const FavoritesContext = createContext();
export const useFavorites = () => useContext(FavoritesContext);

// Algunas pantallas traen el producto con `id` (tal cual lo da la API) y otras
// ya lo normalizan a `_id` antes de llamar a toggleFavorite — normalizar acá,
// en el único punto de entrada/salida de favoritos, evita que una pantalla
// que se le olvide guarde un favorito "roto" sin _id (eso navegaba a
// /product/undefined y tumbaba varias consultas en el backend).
const getId = (p) => p?._id ?? p?.id;

export function FavoritesProvider({ children }) {
  const [favorites, setFavorites] = useState(() => {
    const saved = localStorage.getItem("favorites");
    if (!saved) return [];
    try {
      const parsed = JSON.parse(saved);
      // Autolimpieza: descarta cualquier favorito ya guardado sin id resoluble
      // de una sesión anterior al fix, en vez de arrastrar el dato roto.
      return Array.isArray(parsed) ? parsed.filter((p) => getId(p)) : [];
    } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem("favorites", JSON.stringify(favorites));
  }, [favorites]);

  const toggleFavorite = (product) => {
    const pid = getId(product);
    if (!pid) return; // nada que guardar sin un id válido
    setFavorites((prev) => {
      const exists = prev.some((p) => getId(p) === pid);
      if (exists) return prev.filter((p) => getId(p) !== pid);
      return [...prev, { ...product, _id: pid }];
    });
  };

  return (
    <FavoritesContext.Provider value={{ favorites, toggleFavorite }}>
      {children}
    </FavoritesContext.Provider>
  );
}
